import * as ngCore from '@angular/core'

@ngCore.Component({
  selector: 'atn-ds-accordion',
  standalone: true,
  styleUrls: ['./accordion.component.scss'],
  templateUrl: './accordion.component.html',
})
export class AtnDsAccordionComponent {
  /**
   * Whether the accordion is expanded
   * false
   *
   * @default
   */
  public get isExpanded(): boolean {
    return this._isExpanded
  }

  /** Sets the expanded state of the accordion. */
  @ngCore.Input()
  public set isExpanded(value: boolean) {
    this._isExpanded = value
  }

  private _isExpanded = false

  /* Toggles the expanded state of the accordion. */
  public toggle(): void {
    this._isExpanded = !this._isExpanded
  }
}
